import type { OnBoardingStore } from "@/Modules/OnBoarding/Store";
import type { Language } from "@/Common/Models/Domain/Language";
import { EmailValidationEvent } from "@/Modules/Models/Domain/OnBoarding";

import OnBoardingAPIConnector from "@/Services/TherapyApi/OnBoarding";

import { ApiErrorCodes } from "@/Modules/App/Models/Api/ApiErrorCodes";

import { danger } from "@/Utils/Debug";
import { hasValue } from "@/Utils/Objects";

class SendCodeActionHandler {
  constructor(
    private readonly onBoardingStore: OnBoardingStore,
    private readonly onBoardingApiConnector: OnBoardingAPIConnector = new OnBoardingAPIConnector()
  ) {}

  public async handle(code: string, language: string) {
    this.onBoardingStore.isLoading = true;
    this.onBoardingStore.hasErrorInProcess = false;

    try {
      const sendCodeResponse = await this.onBoardingApiConnector.sendCode({ code });

      if (hasValue(sendCodeResponse.source) && hasValue(sendCodeResponse?.email)) {
        const b2bUser = {
          source: sendCodeResponse.source,
          language: language,
          email: sendCodeResponse.email,
        };

        this.onBoardingStore.setB2BData(b2bUser);
        this.onBoardingStore.setOptionsData(language as Language);
      }

      this.onBoardingStore.sendGTMEvent({
        language: language,
        eventStep: EmailValidationEvent.OK,
      });

      this.onBoardingStore.setNextStep(null);
    } catch (e) {
      this.onBoardingStore.hasErrorInProcess = true;
      this.onBoardingStore.errorCode = ApiErrorCodes.INVALID_CODE;

      this.onBoardingStore.sendGTMEvent({
        language: language,
        eventStep: EmailValidationEvent.KO,
      });

      danger(e);
    } finally {
      this.onBoardingStore.isLoading = false;
    }
  }
}

export default SendCodeActionHandler;
